export {default as default} from './SectionPosts'
